@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.accepttos {
  padding-bottom: 50px;
}

.flex-container {
  display: flex;
  justify-content: center;

  .accept-tos-button button {
    margin-top: 0;
    font-size: 1rem;
    border-radius: 5px;
    width: 11.25rem;
    height: 2.8rem;

    &:disabled {
      background: $grey-light;
    }


    @include mobile {
      font-size: 0.875rem;
      width: 10rem;
      height: 2.25rem;
    }
  }
}

.checkbox-container {
  width: 500px;
  padding: 1rem;

  .checkbox {
    max-width: 500px;
    margin-left: 2rem;

    @include mobile {
      margin-bottom: 1rem;
      margin-left: 0;

    }
  }

  .privacy {
    color: $grey;
    font-size: 0.85rem;
    font-weight: 300;
    line-height: 1.125rem;

    a {
      color: $grey;
    }
  }

  .input {
    margin-top: 1.5rem;
  }
}



.info-wrapper {
  max-width: 500px;
  width: 100%;
  margin: 1rem auto;
}

.infoText {
  text-align: center;
  height: auto;
  font-size: 0.875rem;
  margin-top: 1.625rem;
  line-height: 1.125rem;
  font-weight: 300;
  padding: 1rem;
}

.infoTextHeadline {
  text-transform: uppercase;
  color: $ny-red;
  margin-top: 3rem;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 300;
}


.required-info-container {
  color: #888888;
  font-size: 0.75rem;
  line-height: 0.75rem;
  font-weight: 300;
  text-align: center;
  max-width: 500px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 2rem;

  .required-info {
    margin-top: 1.25rem;
    margin-bottom: 0;

    @include mobile {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }
}
